// src/components/about/MissionSection.js
import React from 'react';
import './MissionSection.css'; // Assurez-vous que ce fichier est créé et utilisé

function MissionSection() {
  return (
    // La classe "about-section" de AboutPage.css fournit le style de base (carte blanche, ombre, etc.)
    // "mission-section" permet d'appliquer des styles spécifiques par-dessus.
    <section className="about-section mission-section">
      <div className="mission-content-wrapper"> {/* Wrapper pour le layout flex */}
        <div className="mission-icon-container">
          <span className="mission-main-icon" role="img" aria-label="Fusée décollant">🚀</span>
        </div>
        <div className="mission-text-container">
          <h2>Notre Mission</h2>
          <p>
            Chez INFO COLAB, notre mission est de concevoir et développer des solutions web 
            <strong className="highlighted-text"> innovantes, performantes et sur mesure </strong> 
            qui aident nos clients à atteindre leurs objectifs stratégiques. Nous croyons en la puissance 
            d'une collaboration étroite pour transformer des idées complexes en expériences numériques 
            intuitives et efficaces.
          </p>
          <p>
            Nous nous engageons à fournir un travail de haute qualité, en utilisant les dernières 
            technologies et en respectant les meilleures pratiques du web pour garantir des 
            résultats durables et évolutifs.
          </p>
        </div>
      </div>
    </section>
  );
}

export default MissionSection;